/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';

import { I18n } from 'react-redux-i18n';
import moment from 'moment-timezone';

import OrderAction from '../app/store/actions/panel';
import PURCHASES from '../data/purchases';

import CartUtil from '../app/utils/cart';
import PriceComponent from '../components/price/Price';
import PurchasesUtils from '../app/utils/purchases';
import { scrollToTopAnimated } from '../components/utils';
import NUMBER from '../helpers/number';
import OrderDetails from '../components/panel/orderDetails/OrderDetails';

class OrderDetailPage extends React.PureComponent {
  // eslint-disable-next-line react/sort-comp
  componentDidMount = () => {
    setTimeout(() => {
      const query = this.props.location.search;
      const id = query.replace('?query=', '');
      const { clientId } = this.props;
      this.props.getOrderDetails(id, clientId);
      scrollToTopAnimated();
    }, 0);
  };

  component;

  orderStatus = (status) => {
    if (status === PURCHASES.orderStatus.CONFIRMED) return I18n.t('done');
    if (status === PURCHASES.orderStatus.PAID) return I18n.t('paid');
    if (status === PURCHASES.orderStatus.PROCESSED) return I18n.t('paid');
    if (status === PURCHASES.orderStatus.DELIVERED) return I18n.t('delivered');
    if (status === PURCHASES.orderStatus.CANCELED) return I18n.t('canceled');
  };

  paymentType = (payment) => {
    if (payment === PURCHASES.paymentType.CREDIT) return I18n.t('credit');
    if (payment === PURCHASES.paymentType.DEBIT) return I18n.t('debit');
    if (payment === PURCHASES.paymentType.BANK_SLIP) return I18n.t('bankSlip');
    if (payment === PURCHASES.paymentType.BILLING) return I18n.t('billing');
    if (payment === PURCHASES.paymentType.ESTIMATE) return I18n.t('estimate');
  };

  paymentStatus = (payment) => {
    if (payment === PURCHASES.paymentStatus.INDEFINITE) {
      return I18n.t('undefined');
    }
    if (payment === PURCHASES.paymentStatus.AUTHORIZED) {
      return I18n.t('authorized');
    }
    if (payment === PURCHASES.paymentStatus.NOT_AUTHORIZED) {
      return I18n.t('notAuthorized');
    }
    if (payment === PURCHASES.paymentStatus.CANCELED) return I18n.t('canceled');
    if (payment === PURCHASES.paymentStatus.CAPTURED) return I18n.t('captured');
  };

  renderTracking = (
    orderDetails,
    track,
    easyConfirm,
    easyConfirmVersion,
    settings = {},
  ) => {
    if (orderDetails.status === PURCHASES.orderStatus.CANCELED) {
      return (
        <div className="panel-timeline">
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">1</div>
            {I18n.t('confirmed')}
            <svg className="icon icon-clipboard-check-solid">
              <use xlinkHref="#icon-clipboard-check-solid" />
            </svg>
          </div>
          <div className="step active">
            <div className="step-line" />
            <div className="step-number">2</div>
            <div style={{ color: 'red' }}>
              {I18n.t('canceled')}
              <svg
                className="icon icon-times-circle-solid"
                style={{ fill: 'red' }}
              >
                <use xlinkHref="#icon-times-circle-solid" />
              </svg>
            </div>
          </div>
        </div>
      );
    }

    if (orderDetails.paymentType === PURCHASES.paymentType.ESTIMATE) {
      return (
        <div className="panel-timeline">
          <div
            className={
              orderDetails.status === PURCHASES.status.CONFIRMED
              || orderDetails.status === PURCHASES.status.FINISHED
                ? 'step active'
                : 'step'
            }
          >
            <div className="step-line" />
            <div className="step-number">1</div>
            {I18n.t('confirmed')}
            <svg className="icon icon-clipboard-check-solid">
              <use xlinkHref="#icon-clipboard-check-solid" />
            </svg>
          </div>
          <div
            className={
              orderDetails.status === PURCHASES.status.FINISHED
                ? 'step active'
                : 'step'
            }
          >
            <div className="step-line" />
            <div className="step-number">2</div>
            {I18n.t('finalized')}
            <svg className="icon icon-check-circle-solid">
              <use xlinkHref="#icon-check-circle-solid" />
            </svg>
          </div>
        </div>
      );
    }

    if (track) {
      const step = PurchasesUtils.getStatus(orderDetails.status);

      return (
        <div className="panel-timeline">
          <div className={step >= 0 ? 'step active' : 'step'}>
            <div className="step-line" />
            <div className="step-number">1</div>
            {I18n.t('beingPrepared')}
            <svg className="icon icon-box-open-solid">
              <use xlinkHref="#icon-box-open-solid" />
            </svg>
          </div>
          <div className={step >= 1 ? 'step active' : 'step'}>
            <div className="step-line" />
            <div className="step-number">2</div>
            {I18n.t('readToSend')}
            <svg className="icon icon-people-carry-solid">
              <use xlinkHref="#icon-people-carry-solid" />
            </svg>
          </div>
          <div className={step >= 2 ? 'step active' : 'step'}>
            <div className="step-line" />
            <div className="step-number">3</div>
            {I18n.t('inTransport')}
            <svg className="icon icon-truck-solid">
              <use xlinkHref="#icon-truck-solid" />
            </svg>
          </div>
          <div className={step >= 3 ? 'step active' : 'step'}>
            <div className="step-line" />
            <div className="step-number">4</div>
            {I18n.t('delivered')}
            <svg className="icon icon-check-square-solid">
              <use xlinkHref="#icon-check-square-solid" />
            </svg>
          </div>
        </div>
      );
    }

    const occurrences = (orderDetails.invoices
        && orderDetails.invoices[0]
        && orderDetails.invoices[0].occurrences)
      || {};
    let step = PurchasesUtils.getStatus(orderDetails.status);

    if (
      orderDetails.isDeliveryClient == '1'
      || orderDetails.isDeliveryClient === '2'
    ) {
      if (orderDetails.deliveryCode) step = 5;
      if (status === PURCHASES.orderStatus.INVOICES_ISSUED) step = 4;
    }

    let dataCriacao = '';
    let dataPrevisao = '';
    let dataEntrega = '';
    if (easyConfirmVersion && easyConfirmVersion >= '3.0') {
      dataCriacao = occurrences.dataCriacao ? occurrences.dataCriacao : '';
      // eslint-disable-next-line no-nested-ternary
      dataPrevisao = occurrences.dataPrevisao
        ? occurrences.dataPrevisao
        : occurrences.dataReprogramada
          ? occurrences.dataReprogramada
          : '';
      dataEntrega = occurrences.entrega && occurrences.entrega.dataEntrega
        ? occurrences.entrega.dataEntrega
        : '';
    } else if (occurrences.embarque) {
      dataCriacao = occurrences.embarque.dataCriacao
        ? occurrences.embarque.dataCriacao.$
        : '';
      dataPrevisao = occurrences.embarque.dataPrevisao
        ? occurrences.embarque.dataPrevisao.$
        : '';
      dataEntrega = occurrences.embarque.dataEntrega
        ? occurrences.embarque.dataEntrega.$
        : '';
    }

    if (easyConfirm && occurrences) {
      if (dataCriacao) {
        step = 4;
      }
      if (dataPrevisao) {
        step = 5;
      }
      if (dataEntrega) {
        step = 6;
      }
    }

    let paymentOk = null;

    if (settings.paymentService === 'pagseguro') {
      paymentOk = orderDetails.paymentType === PURCHASES.paymentType.BILLING
        || orderDetails.paymentType === PURCHASES.paymentType.ESTIMATE
        || orderDetails.paymentStatus === PURCHASES.paymentStatusPagSeguro.PAID
        || orderDetails.paymentStatus === PURCHASES.paymentStatusPagSeguro.DEBITED;
    } else {
      paymentOk = orderDetails.paymentType === PURCHASES.paymentType.BILLING
        || orderDetails.paymentType === PURCHASES.paymentType.ESTIMATE
        || orderDetails.paymentStatus === PURCHASES.paymentStatus.AUTHORIZED
        || orderDetails.paymentStatus === PURCHASES.paymentStatus.CAPTURED;
    }

    const paymentLabel = paymentOk
      ? I18n.t('paymentMade')
      : orderDetails.paymentStatusReasonDesc
        || `${I18n.t('payment')}\n${I18n.t(
          PurchasesUtils.paymentStatus(orderDetails.paymentStatus),
        )}`;

    const paymentStyleColor = paymentOk ? '' : 'tomato';
    const bgStyleWarning = paymentOk
      ? {}
      : {
        backgroundColor: paymentStyleColor,
        border: `5px solid ${paymentStyleColor}`,
        color: '#fff',
      };
    const fontStyleWarning = paymentOk
      ? {}
      : { color: paymentStyleColor, fontWeight: '600' };
    let countPosition = 0;

    return (
      <div className="panel-timeline">
        <div className={step >= 0 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">{++countPosition}</div>
          {I18n.t('orderMade')}
          <svg className="icon icon-clipboard-check-solid">
            <use xlinkHref="#icon-clipboard-check-solid" />
          </svg>
        </div>
        <div className={step >= 1 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number" style={bgStyleWarning}>
            {++countPosition}
          </div>
          <span style={fontStyleWarning}>{paymentLabel}</span>
          {paymentOk ? (
            <svg className="icon icon-dollar-sign-solid">
              <use xlinkHref="#icon-dollar-sign-solid" />
            </svg>
          ) : (
            <svg className="icon icon-times-circle-solid">
              <use xlinkHref="#icon-times-circle-solid" />
            </svg>
          )}
        </div>
        <div className={step >= 2 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">{++countPosition}</div>
          {I18n.t('picking')}
          <svg className="icon icon-warehouse-solid">
            <use xlinkHref="#icon-warehouse-solid" />
          </svg>
        </div>
        <div className={step >= 3 ? 'step active' : 'step'}>
          <div className="step-line" />
          <div className="step-number">{++countPosition}</div>
          {I18n.t('invoiceIssued')}
          <svg className="icon icon-copy-solid">
            <use xlinkHref="#icon-copy-solid" />
          </svg>
        </div>
        {(orderDetails.isDeliveryClient === '1'
          || orderDetails.isDeliveryClient === '2') && (
          <React.Fragment>
            <div className={step >= 4 ? 'step active' : 'step'}>
              <div className="step-line" />
              <div className="step-number">{++countPosition}</div>
              {I18n.t('availableCustumer')}
              <svg className="icon icon-home-solid">
                <use xlinkHref="#icon-home-solid" />
              </svg>
            </div>
            <div className={step >= 6 ? 'step active' : 'step'}>
              <div className="step-line" />
              <div className="step-number">{++countPosition}</div>
              {I18n.t('delivered')}
              <svg className="icon icon-check-circle-solid">
                <use xlinkHref="#icon-check-circle-solid" />
              </svg>
            </div>
          </React.Fragment>
        )}
        {easyConfirm && orderDetails.isDeliveryClient === '0' && (
          <React.Fragment>
            <div className={step >= 4 ? 'step active' : 'step'}>
              <div className="step-line" />
              <div className="step-number">{++countPosition}</div>
              {I18n.t('deliveredToCarrier')}
              <svg className="icon icon-truck-loading-solid">
                <use xlinkHref="#icon-truck-loading-solid" />
              </svg>
            </div>
            <div className={step >= 5 ? 'step active' : 'step'}>
              <div className="step-line" />
              <div className="step-number">{++countPosition}</div>
              <span>
                {I18n.t('outForDelivery')}
                {occurrences
                  && dataPrevisao
                  && ` ${I18n.t('outForDeliveryPrev')} ${dataPrevisao.substr(
                    0,
                    10,
                  )}`}
              </span>
              <svg className="icon icon-truck-solid">
                <use xlinkHref="#icon-truck-solid" />
              </svg>
            </div>
            <div className={step >= 6 ? 'step active' : 'step'}>
              <div className="step-line" />
              <div className="step-number">{++countPosition}</div>
              {I18n.t('delivered')}
              <svg className="icon icon-check-circle-solid">
                <use xlinkHref="#icon-check-circle-solid" />
              </svg>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  };

  downloadXML = (invoiceNumber, xml) => {
    const linkSource = `data:application/xml;base64,${xml}`;
    const downloadLink = document.createElement('a');
    const fileName = `nf_${invoiceNumber}.xml`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  downloadPDF = (invoiceNumber, pdf) => {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    const fileName = `nf_${invoiceNumber}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  downloadInvoices = async (idInvoice, invoiceNumber) => {
    console.log(invoiceNumber);
    await this.props.getInvoices(idInvoice, invoiceNumber);
  };

  render() {
    const {
      orderDetails,
      easyConfirm,
      taxName,
      selectedContract,
      pricePermission,
      companyTag,
      easyConfirmVersion,
      settings = {},
    } = this.props;

    const items = ((orderDetails && orderDetails.items) || []).map(item => ({
      total: item.amount,
      product: {
        price: {
          value: item.price,
          icmsST: item.icmsST || 0,
        },
      },
    }));

    const paymentTerms = selectedContract.clientDetails
      && selectedContract.clientDetails.paymentTermsLabel
      && selectedContract.clientDetails.paymentTermsLabel.description;

    if (!orderDetails) {
      return <div style={{ height: '100vh', backgroundColor: 'white' }} />;
    }

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('orderDetail')}</h1>

            {this.renderTracking(
              orderDetails,
              undefined,
              easyConfirm,
              easyConfirmVersion,
              settings,
            )}

            <div className="panel-content" style={{ marginBottom: 10 }}>
              <div
                className="box box-50"
              >
                <h2 className="box-title">
                  <span>{I18n.t('downloadInvoice')}</span>
                </h2>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: 'row',
                  gap: 10,
                }}
                >
                  {orderDetails.invoices && orderDetails.invoices.length > 0 ? (
                    orderDetails.invoices.map((invoice, index) => (
                      <button
                        key={index}
                        type="button"
                        className="btn"
                        style={{ fontSize: 12 }}
                        onClick={() => this.downloadInvoices(
                          invoice.accessKey,
                          invoice.invoiceNumber,
                        )}
                      >
                        {`${I18n.t('salesInvoice')} - ${
                          invoice.invoiceNumber
                        }`}
                      </button>
                    ))
                  ) : (
                    <p>{I18n.t('withoutInvoice')}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="panel-content">
              <div className="box box-50">
                <h2 className="box-title">
                  <span>{I18n.t('details2')}</span>
                </h2>
                <div>
                  {I18n.t('code2')}
                  {orderDetails.id}
                  <br />
                  {orderDetails.sphereNumber && (
                    <React.Fragment>
                      {I18n.t('codeSphere')}

                      {orderDetails.sphereNumber}
                      <br />
                    </React.Fragment>
                  )}
                  {orderDetails.savedId && (
                    <React.Fragment>
                      {I18n.t('codeSolicitation')}

                      {orderDetails.savedId}
                      <br />
                    </React.Fragment>
                  )}
                  {orderDetails.paymentType && (
                    <React.Fragment>
                      {I18n.t('paymentType2')}
                      {' '}
                      {this.paymentType(orderDetails.paymentType)}
                      {paymentTerms && orderDetails.paymentType === 'billing'
                        ? ` - ${paymentTerms}`
                        : ''}
                      <br />
                    </React.Fragment>
                  )}
                  {!!orderDetails.status
                    && orderDetails.paymentType
                      !== PURCHASES.paymentType.ESTIMATE && (
                      <React.Fragment>
                        {I18n.t('documentStatus3')}
                        {' '}
                        {this.orderStatus(orderDetails.status)}
                        <br />
                      </React.Fragment>
                  )}
                  {orderDetails.paymentType
                    !== PURCHASES.paymentType.ESTIMATE && (
                    <React.Fragment>
                      {I18n.t('price2')}
                      {' '}
                      <PriceComponent value={Number(orderDetails.value)} />
                      <br />
                    </React.Fragment>
                  )}
                  <p>
                    {I18n.t('buyDate2')}
                    {' '}
                    {moment(orderDetails.createdAt).format('LLL')}
                  </p>
                  {orderDetails.paymentType
                    === PURCHASES.paymentType.BANK_SLIP
                    && orderDetails.status === PURCHASES.orderStatus.CONFIRMED && (
                      <React.Fragment>
                        <br />
                        <div
                          className="cursorPointer"
                          onClick={() => window.open(
                            orderDetails.paymentBankSlipUrl,
                            '_blank',
                            'width=500,height=500',
                          )
                          }
                          role="presentation"
                          style={{ width: 'fit-content' }}
                        >
                          <span
                            className="checkout-image-bar"
                            style={{
                              backgroundImage:
                                'url(/images/codigo-de-barras.svg)',
                              marginTop: 0,
                            }}
                          />
                          <p style={{ fontSize: 'small' }}>
                            {I18n.t('bankSlipVisualize')}
                          </p>
                        </div>
                      </React.Fragment>
                  )}
                  {settings.paymentService === 'pagseguro'
                    && orderDetails.paymentType === PURCHASES.paymentType.DEBIT
                    && orderDetails.status === PURCHASES.orderStatus.CONFIRMED && (
                      <button
                        type="button"
                        className="btn"
                        style={{ marginTop: 20 }}
                        onClick={() => window.open(
                          orderDetails.paymentOnlineDebitUrl,
                          '_blank',
                          'width=500,height=500',
                        )
                        }
                      >
                        {I18n.t('debitOn')}
                      </button>
                  )}
                  {orderDetails.invoices && orderDetails.invoices.length && (
                    <div style={{ display: 'flex' }}>
                      <div className="box box-50">
                        {orderDetails.invoices.map(invoice => (invoice.xml ? (
                          <button
                            type="button"
                            className="btn"
                            style={{ marginTop: 20 }}
                            onClick={() => this.downloadXML(
                              invoice.invoiceNumber,
                              invoice.xml,
                            )
                              }
                          >
                            {`${I18n.t('downloadXML')} - ${
                              invoice.invoiceNumber
                            }`}
                          </button>
                        ) : (
                          false
                        )))}
                      </div>
                      <div className="box box-50">
                        {orderDetails.invoices.map(invoice => (invoice.pdf ? (
                          <button
                            type="button"
                            className="btn"
                            style={{ marginTop: 20 }}
                            onClick={() => this.downloadPDF(
                              invoice.invoiceNumber,
                              invoice.pdf,
                            )
                              }
                          >
                            {`${I18n.t('downloadPDF')} - ${
                              invoice.invoiceNumber
                            }`}
                          </button>
                        ) : (
                          false
                        )))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {orderDetails.address && (
                <div className="box box-50">
                  <h2 className="box-title">
                    <span>{I18n.t('delivery')}</span>
                  </h2>
                  {I18n.t('checkoutDeliveryHeaderTwo')}
                  {' '}
                  {!Number(orderDetails.isDeliveryClient)
                    ? I18n.t('normalDelivery')
                    : Number(orderDetails.isDeliveryClient) === 2
                      ? I18n.t('pickUpAtLockerStore')
                      : I18n.t('storeTake')}
                  <br />
                  {I18n.t('name2')}
                  {' '}
                  {orderDetails.address.name}
                  <br />
                  {I18n.t('address2')}
                  {' '}
                  {orderDetails.address.address}
                  <br />
                  {I18n.t('province2')}
                  {' '}
                  {orderDetails.address.province}
                  <br />
                  {I18n.t('cityAndState')}
                  {' '}
                  {`${orderDetails.address.city} - ${orderDetails.address.state}`}
                  <br />
                  {I18n.t('cep2')}
                  {' '}
                  {NUMBER.cepMask(orderDetails.address.cep)}
                  <br />
                  {I18n.t('country2')}
                  {' '}
                  {orderDetails.address.country}
                </div>
              )}

              {!!orderDetails.cart && (
                <React.Fragment>
                  <h2 className="box-view-title">
                    <span>{I18n.t('cartHistory')}</span>
                  </h2>
                  <div className="box-view box-b-bottom">
                    <div
                      className={
                        orderDetails.cart.user_approver2
                          ? 'box box-30'
                          : 'box box-50'
                      }
                    >
                      {`${I18n.t('requester')}: `}
                      {' '}
                      {orderDetails.cart.user.name}
                      <br />
                      {`${I18n.t('email')}: `}
                      {' '}
                      {orderDetails.cart.user.email}
                      <br />
                      {`${I18n.t('requestDate')}: `}
                      {' '}
                      {moment(orderDetails.cart.createdAt).format('DD/MM/YYYY')}
                      <br />
                    </div>

                    {!!orderDetails.cart.user_approver1 && (
                      <div
                        className={
                          orderDetails.cart.user_approver2
                            ? 'box box-30'
                            : 'box box-50'
                        }
                      >
                        {`${I18n.t('approver')} 1: `}
                        {' '}
                        {orderDetails.cart.user_approver1.name}
                        <br />
                        {`${I18n.t('email')}: `}
                        {' '}
                        {orderDetails.cart.user_approver1.email}
                        <br />
                        {`${I18n.t('approvalDate')}: `}
                        {' '}
                        {moment(
                          orderDetails.cart.approverDate1
                            || orderDetails.createdAt,
                        ).format('DD/MM/YYYY')}
                        <br />
                      </div>
                    )}

                    {!!orderDetails.cart.user_approver2 && (
                      <div className="box box-30">
                        {`${I18n.t('approver')} 2: `}
                        {' '}
                        {orderDetails.cart.user_approver2.name}
                        <br />
                        {`${I18n.t('email')}: `}
                        {' '}
                        {orderDetails.cart.user_approver2.email}
                        <br />
                        {`${I18n.t('approvalDate')}: `}
                        {' '}
                        {moment(
                          orderDetails.cart.approverDate2
                            || orderDetails.createdAt,
                        ).format('DD/MM/YYYY')}
                        <br />
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}

              <div className="box box-b-bottom">
                <h2 className="box-title">
                  <span>{I18n.t('products2')}</span>
                </h2>
                {orderDetails.items.map((item, index) => (
                  <React.Fragment key={item.purchaseProduct.description}>
                    {index > 0 && (
                      <div
                        style={{
                          borderBottom: '1px solid #7C7E83',
                          marginTop: 4,
                          marginBottom: 10,
                        }}
                      />
                    )}
                    <p>{item.purchaseProduct.description}</p>
                    <ul>
                      {/* Código Produto Sonepar - productId | Código Item Cliente - productClientCode | Código Nortel - purchaseProduct.code | Ordem de Compra - clientNumber */}
                      <li>
                        {I18n.t('purchaseOrder')}
                        {' '}
                        {orderDetails.clientNumber
                          ? orderDetails.clientNumber
                          : I18n.t('null')}
                      </li>
                      <li>
                        {I18n.t('clientItemCode')}
                        {' '}
                        {item.productClientCode}
                      </li>
                      <li>
                        {I18n.t('nortelCode')}
                        {' '}
                        {item.purchaseProduct.code}
                      </li>
                      <li>
                        {I18n.t('quantity2')}
                        {' '}
                        {item.amount}
                        {pricePermission && !item.billingLeft && (
                          <span>
                            {I18n.t('price2')}
                            {' '}
                            <PriceComponent
                              value={Number(item.price * item.amount)}
                            />
                          </span>
                        )}
                      </li>
                      <li>
                        {`${I18n.t('bidSize2')} ${
                          item.mandatoryQuantity || ''
                        }`}
                      </li>
                      {item.billingLeft && (
                        <li>
                          {I18n.t('billed')}
                          {' '}
                          {Number(item.amount) - Number(item.billingLeft)}
                          {pricePermission && (
                            <span>
                              {I18n.t('price2')}
                              {' '}
                              <PriceComponent
                                value={Number(item.price * item.amount)}
                              />
                            </span>
                          )}
                        </li>
                      )}
                    </ul>
                  </React.Fragment>
                ))}
              </div>

              {pricePermission && (
                <div className="box">
                  <h2 className="box-title">
                    <span>{I18n.t('totalValue')}</span>
                  </h2>
                  <ul>
                    <li>
                      <span>{I18n.t('subTotal')}</span>
                      <span>
                        <PriceComponent
                          value={CartUtil.getCartTotal(
                            items,
                            true,
                            undefined,
                            undefined,
                            companyTag,
                          )}
                          force
                        />
                      </span>
                    </li>
                    <li>
                      <span>{taxName}</span>
                      <span>
                        <PriceComponent
                          value={CartUtil.getCartSt(items, companyTag)}
                          force
                        />
                      </span>
                    </li>
                    <li>
                      <span>{I18n.t('total')}</span>
                      <span>
                        <PriceComponent value={Number(orderDetails.value)} />
                      </span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapDispatchToState = dispatch => ({
  getOrderDetails: (id, clientId) => dispatch(OrderAction.getOrderDetails(id, clientId, false)),
  getInvoices: (id, invoiceNumber) => dispatch(OrderAction.getInvoices(id, invoiceNumber)),
});

const mapStateToProps = state => ({
  pricePermission:
    state.contracts.selected && state.contracts.selected.pricePermission,
  clientId: state.contracts.selected.client.id,
  orderDetails: state.panel.orderDetails,
  easyConfirm: state.settings.confirmaFacil,
  easyConfirmVersion: state.settings.confirmaFacilVersion,
  taxName: state.settings && state.settings.taxName,
  selectedContract: state.contracts.selected,
  companyTag: state.settings.companyTag,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToState)(OrderDetailPage);
